// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
	dirty: true,
	raw: 'v1.0.0-11-gcf11e0d-dirty',
	hash: 'gcf11e0d',
	distance: 11,
	tag: 'v1.0.0',
	semver: {
		options: {
			loose: false,
			includePrerelease: false
		},
		loose: false,
		raw: 'v1.0.0',
		major: 1,
		minor: 0,
		patch: 0,
		prerelease: [],
		build: [],
		version: '1.0.0'
	},
	suffix: '11-gcf11e0d-dirty',
	semverString: '1.0.0+11.gcf11e0d',
	version: '1.1.0',
	buildDate: '2021-07-05T06:23:52.446Z'
};
/* tslint:enable */
